import styled from 'styled-components';

export const Content = styled.div`
  &.ant-layout-content {
    margin: 24px 16px;
    background-color: #fff;
  }
`;
